<template>
  <div class="" style="">
    <!-- <h1 class="section-title" style="text-transform: uppercase; font-weight: 400; color: #000; font-size: 21px;">Favorite Quotes</h1> -->
    <h3 class="dashboard-header" style="">Favorite Quotes</h3>
    <hr>
    <div v-for="quote in quotes" :key="quote.id" @click="showEditModal(quote)" style="cursor: pointer;">
      <p style="font-style: italic;">{{ quote.quote_content }}</p>
      <p>- {{ quote.author }}</p>
      <hr>
    </div>
    <!-- {{ user_id }} -->
    <!-- <div>
      <input type="text" name="" id="" class="form-control"></input>
    </div> -->
    <button v-if="!quotes[0]" class="btn btn-primary mt-2" @click="showModal">+ Add Quote</button>
    <button v-if="quotes[0]" class="btn btn-primary mt-2" @click="showModal">+</button>

    <!-- ---- QUOTE MODAL ---- -->
    <!-- Need to raise the z-index above the sticky side bar (which is something like 1200) -->
    <modal name="quote" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-4">
        <h4 v-if="!editing" style="">Add Quote</h4>
        <h4 v-if="editing" style="">Edit Quote</h4>
        <form action="" class="">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="content">Quote</label>
              <textarea class="form-control" id="content" rows="3" v-model="quoteContent" placeholder="To run or not to run..."></textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="author">Author</label>
              <input type="text" class="form-control" id="author" placeholder="" v-model="author">
            </div>
          </div>
          <hr>
          <div v-if="editing" class="web-only">
            <button class="btn btn-info mr-1 mt-2" @click.prevent="closeModal">Cancel</button><button class="btn btn-danger mt-2" @click.prevent="deleteQuote(editQuote.id)" style="">Delete Quote</button><button class="btn btn-primary mt-2 mb-4" @click.prevent="updateQuote(editQuote.id)" style="float: right;">Update Quote</button>
          </div>
          <div v-if="editing" class="mobile-only">
            <button class="btn btn-info mr-1 mt-2" @click.prevent="closeModal">Cancel</button><button class="btn btn-danger mt-2" @click.prevent="deleteQuote(editQuote.id)" style="">Delete</button><button class="btn btn-primary mt-2 mb-4" @click.prevent="updateQuote(editQuote.id)" style="float: right;">Update Quote</button>
          </div>
          <div v-if="!editing">
            <button class="btn btn-info mr-1" @click.prevent="closeModal">Cancel</button><button class="btn btn-primary" @click.prevent="saveQuote()" style="float: right;">Save Quote</button>
          </div>
        </form>
      </div>
    </modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { required } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373

  export default {
    props: ['user'],
    data () {
      return {
        // showTargetRaceForm: true,
        // user_id: 0,
        // quotes: [
        //   {quote_content: 'Just do it.', author: 'Nike'},
        // ],
        quotes: [],
        editing: false,
        quoteContent: '',
        author: '',
        saveClicked: false,
        editQuote: null,
        user: null, // Somehow everything seemed to work just fine without this
      }
    },
    validations: {
      quoteContent: {
        required,
      },
      author: {
        required,
      },
    },
    created () {
      // this.getUserProfile();
      this.getQuotes();
    },
    // mounted () {
    //   this.get_user_id();
    //   this.get_quotes();
    // },
    methods: {
      // get_user_id() {
      //   this.user_id = this.$store.getters.user_id;
      // },
      getUserProfile () {
        this.$store.dispatch('getUser').then(() => { // Lecture 360
          this.user = this.$store.getters.user
          // this.distanceUnits = this.user.preferred_distance_units
          console.log(this.$store.getters.user)
          this.getQuotes();
        })
      },
      // get_quotes () {
      getQuotes () {
        console.log('Getting quotes');
        // let api_url = 'quotes/?user='.concat(this.user_id.toString());
        // // this.$http.get('quotes/')
        // this.$http.get(api_url)
        //   .then(response => response.json())
        //   .then(data => {
        //     if (data) {
        //       console.log(data);
        //       this.quotes = data;
        //     }
        //   });

        // Vue.http.get('stockdata.json')
        // .then(response => response.json())
        // .then(data => {
        //   if (data) {
        //     const stocks = data.stocks;
        //     const funds = data.funds;
        //     const stockPortfolio = data.stockPortfolio;

        //     const portfolio = {
        //       stockPortfolio,
        //       funds
        //     };

        //     commit('SET_STOCKS', stocks);
        //     commit('SET_PORTFOLIO', portfolio);
        //   }
        // });
        axios.get('/api/quotes/?user='.concat(this.user.id.toString()))
          .then(res => {
            console.log(res)
            this.quotes = res.data
          })
          .catch(error => console.log(error))
      },
      saveQuote () {
        this.saveClicked = true

        console.log(this.quoteContent)
        console.log(this.author)

        axios.post('/api/quotes/',
          {
            user: this.user.id, // https://stackoverflow.com/questions/39001486/posting-a-foreign-key-relationship-in-django-rest-framework
            quote_content: this.quoteContent,
            author: this.author,
          }
        )
          .then(res => {
            console.log(res)
            this.getQuotes() // Refresh the list of quotes after adding a new one
            this.clearQuoteForm()
            this.closeModal() // Close the quote modal
            this.saveClicked = false
          })
          .catch(error => console.log(error))
      },
      updateQuote (quoteID) {
        console.log('Updating quote: '.concat(quoteID.toString()))
        this.updateClicked = true

        axios.patch('/api/quotes/'.concat(quoteID.toString()).concat('/'),
          {
            quote_content: this.quoteContent,
            author: this.author,
          }
        )
          .then(res => {
            console.log(res)
            this.getQuotes() // Refresh the list of quotes after editing one
            this.clearQuoteForm()
            this.closeModal() // Close the quote modal
            this.updateClicked = false
          })
          .catch(error => {
            console.log(error)
          })
      },
      showModal() {
        this.editing = false
        this.$modal.show('quote'); // npmjs.com/package/vue-js-modal
      },
      showEditModal(quote) {
        this.editing = true

        this.editQuote = quote
        this.quoteContent = quote.quote_content
        this.author = quote.author
        this.$modal.show('quote'); // npmjs.com/package/vue-js-modal
      },
      closeModal() {
        this.$modal.hide('quote'); // npmjs.com/package/vue-js-modal
        this.clearQuoteForm()
      },
      deleteQuote(quoteID) {
        console.log(quoteID)
        axios.delete('/api/quotes/'.concat(quoteID.toString()).concat('/'))
          .then(res => {
            console.log(res)
            this.getQuotes() // Refresh the list of quotes after deleting one
            this.$modal.hide('quote'); // npmjs.com/package/vue-js-modal
          })
          .catch(error => console.log(error))
      },
      clearQuoteForm() {
        this.quoteContent = ''
        this.author = ''

        this.editing = false
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/myrundash/dashboard/Quotes.vue